// extracted by mini-css-extract-plugin
export default {"PlusIcon":"plus-icon_PlusIcon__2FnaA"};